import { render } from "./SpChangeShopModal.vue?vue&type=template&id=6be87fdf&scoped=true"
import script from "./SpChangeShopModal.vue?vue&type=script&lang=js"
export * from "./SpChangeShopModal.vue?vue&type=script&lang=js"

import "./SpChangeShopModal.vue?vue&type=style&index=0&id=6be87fdf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be87fdf"]])

export default __exports__